export default __webpack_public_path__ + "static/media/image4.8e1147ea.png";